import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading1: {
		id: 'schools.thankyou.heading1',
		defaultMessage: 'Thank you, teachers!',
		description: 'Calm Schools Thank You heading text',
	},
	heading2: {
		id: 'schools.thankyou.heading2',
		defaultMessage: 'You make a difference in the world.',
		description: 'Calm Schools Thank You heading text',
	},
	button: {
		id: 'schools.thankyou.button',
		defaultMessage: 'Get started',
		description: 'Calm Schools Thank You call to action text',
	},
});
